export default __webpack_public_path__ + "static/media/work.43507cae.jpg";